import notificationTypes from 'plugins/i18n/notificationTypes.en.ts'

export default {
	notifications: {
		markAllAsRead: 'Mark all as read',
		loaded: 'loaded',
		noInformationAvailable: 'No information available',
		noneFound: 'There are no {status} notifications',
		new: 'new',
		sentOn: 'Sent on',
		unread: 'Unread',
		read: 'Read',
		all: 'All',
		show_notification: 'Show notification',
		notification_already_read: 'This notification has already been read',
		mark_as_read: 'Mark as read',
		read_notifications: 'read',
		sender: 'Sender',
		notificationTypes: notificationTypes,
	},
}
